import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo } from 'react';
import { defaults } from '@hh.ru/magritte-common-number-formatter';
import { Input } from './Input.js';
import { numberFormatterFactory } from './numberFormatter.js';
import './BaseInput.js';
import 'classnames';
import '@hh.ru/magritte-common-mouse';
import '@hh.ru/magritte-common-text-selection';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-common-use-multiple-refs';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-form-helper';
import '@hh.ru/magritte-ui-icon/icon';
import './useFocus.js';
import './useInputAriaProps.js';
import '@hh.ru/magritte-ui-typography';

const NumberInput = forwardRef(({ groupSeparator = defaults.groupSeparator, decimalMark = defaults.decimalMark, groupSize = defaults.groupSize, decimalLength = defaults.decimalLength, allowNegative = defaults.allowNegative, ...restProps }, ref) => {
    const numberFormatter = useMemo(() => {
        return numberFormatterFactory({ groupSeparator, decimalMark, groupSize, decimalLength, allowNegative });
    }, [groupSeparator, decimalMark, groupSize, decimalLength, allowNegative]);
    return jsx(Input, { ...restProps, inputMode: "decimal", formatter: numberFormatter, ref: ref });
});
NumberInput.displayName = 'NumberInput';

export { NumberInput };
//# sourceMappingURL=NumberInput.js.map
